import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornato, Fabio!");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-md">
          <Link to="/" className="block text-center mb-12">
            <span className="font-display text-3xl tracking-tight text-[#1C1917]">
              Il Cassetto delle <span className="italic text-[#9F583F]">Giraffe</span>
            </span>
          </Link>
          <p className="label-ui text-[#9F583F] text-center mb-3">Area autore</p>
          <h1 className="font-display text-4xl tracking-tight text-[#1C1917] text-center mb-10">
            Accedi per scrivere
          </h1>

          <form onSubmit={submit} data-testid="login-form">
            <label className="label-ui text-[#57534E] block mb-2">Email</label>
            <Input
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="font-body rounded-none border-x-0 border-t-0 border-b border-[#E7E5E4] bg-transparent px-0 focus-visible:ring-0 focus-visible:border-[#9F583F] text-lg mb-8"
            />
            <label className="label-ui text-[#57534E] block mb-2">Password</label>
            <Input
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="font-body rounded-none border-x-0 border-t-0 border-b border-[#E7E5E4] bg-transparent px-0 focus-visible:ring-0 focus-visible:border-[#9F583F] text-lg mb-8"
            />
            {error && (
              <p className="font-ui text-sm text-[#9F583F] mb-6" data-testid="login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full rounded-none bg-[#1C1917] hover:bg-[#9F583F] text-white label-ui py-6 h-auto transition-colors"
            >
              {loading ? "Accesso…" : "Entra"}
            </Button>
          </form>

          <Link
            to="/"
            className="block text-center mt-10 label-ui text-[#57534E] hover:text-[#9F583F] transition-colors"
          >
            ← Torna al blog
          </Link>
        </div>
      </div>
    </div>
  );
}
